import LoginP from "./page";
import LoginC from "./component";
import LoginM from "./modularization";
import UserAgreement from "./components/UserAgreement";
import GraphicCode from "./components/GraphicCode";
import ServiceApi from "./services"


const Login = {
  LoginC,
  LoginP,
  LoginM,
  UserAgreement,
  GraphicCode,
  ServiceApi
};

export default Login;
